import React, { createContext, useContext, useMemo, useState } from 'react';

const QuizContext = createContext({
  quizData: { isComplete: false, results: null },
  completeQuiz: () => {},
  hideSiteChrome: false,
  setHideSiteChrome: () => {},
  resultsVisible: false,
  setResultsVisible: () => {},
});

export const useQuiz = () => useContext(QuizContext);

export const QuizProvider = ({ children }) => {
  const [quizData, setQuizData] = useState({
    isComplete: false,
    results: null,
  });
  const [hideSiteChrome, setHideSiteChrome] = useState(false);
  /** Results screen of a sitting (still on /quiz/*) — navbar returns, CTAs stay on the page. */
  const [resultsVisible, setResultsVisible] = useState(false);

  const completeQuiz = (results) => {
    setQuizData((prev) => ({ ...prev, isComplete: true, results }));
  };

  const value = useMemo(
    () => ({
      quizData,
      completeQuiz,
      hideSiteChrome,
      setHideSiteChrome,
      resultsVisible,
      setResultsVisible,
    }),
    [quizData, hideSiteChrome, resultsVisible]
  );

  return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
};
